import { createStyles, Theme } from '@nelnet/unifi-components-react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const styles = ({ spacing, breakpoints }: Theme) =>
  createStyles({
    container: {
      borderLeft: '1px solid #000000',
    },
    image: {
      display: 'flex',
      alignItems: 'flex-start',
      maxWidth: '250px',
      margin: '1rem 1rem 1rem 0',
      [breakpoints.up('sm')]: {
        maxWidth: '500px',
      },
      [breakpoints.up('md')]: {
        maxWidth: '650px',
      },
      [breakpoints.up('lg')]: {
        maxWidth: '850px',
      },
    },
    noBorder: {
      border: 'none',
      marginRight: '4rem',
      [breakpoints.up('lg')]: {
        marginRight: '3rem',
      },
    },
    border: {
      borderLeft: '1px solid #000000',
      margin: `${spacing(3)}px ${spacing(6)}px ${spacing(1)}px ${spacing(2)}px`,
    },
    body: {
      textAlign: 'left',
    },
    exampleBody: {
      textAlign: 'left',
      paddingTop: `${spacing(2)}px`,
    },
  });

export default styles;
